/* PhoneHub tab bar — My Phone type tiles (Cases / Screen / Camera / Other).
   Loaded from sections/ph-topbar.liquid (every page); images and CSS URLs come
   from the script tag's data-* attributes.
   1. Turns the device view's four shortcut tiles into type tiles: illustrated
      images (assets/ph-type-*.svg), labels and the section tag to filter by.
   2. Follows the "All accessories" link (set by ph-tab-bar.js to the chosen
      phone's collection) and points each tile at that collection filtered by its
      tag (/collections/<handle>/<tag>), so the collection page opens with that
      type selected in "Shop by type".
   3. Shows item counts and hides types the phone has no products for (same
      ?view=ph-sections feed and sessionStorage cache as the collection bar). */
(function () {
  'use strict';
  var script = document.currentScript;
  var TYPES = [
    { key: 'cases', label: 'Cases', tag: 'phone-case', feed: 'phone case' },
    { key: 'screen', label: 'Screen protection', tag: 'screen-protection', feed: 'screen protection' },
    { key: 'camera', label: 'Camera protection', tag: 'camera-protection', feed: 'camera protection' },
    { key: 'other', label: 'Other', tag: 'phone-gadgets', feed: 'phone gadgets' }
  ];
  var FEED = {};
  TYPES.forEach(function (t) { FEED[t.key] = t.feed; });
  var TTL = 600000;

  function data(name) { return script ? script.getAttribute('data-' + name) : null; }

  function colPath(u) {
    var m = /^(?:https?:\/\/[^\/]+)?(\/collections\/[^\/?#]+)/.exec(u || '');
    return m ? m[1] : null;
  }

  function addCss() {
    var href = data('css');
    if (!href || document.querySelector('link[data-ph-type-tiles]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.setAttribute('data-ph-type-tiles', '');
    document.head.appendChild(l);
  }

  // Rewrite the four shortcut tiles rendered by ph-tab-bar.liquid (in order).
  function upgrade(view) {
    var tiles = Array.prototype.slice.call(view.querySelectorAll('.phtb-sc:not(.phtb-sc--main)'));
    tiles.slice(0, TYPES.length).forEach(function (a, i) {
      var t = TYPES[i];
      if (a.getAttribute('data-phtb-tag')) return; // already a type tile
      a.setAttribute('data-phtb-sc', t.key);
      a.setAttribute('data-phtb-tag', t.tag);
      a.setAttribute('href', '#');
      var media = a.querySelector('.phtb-sc__media');
      var src = data('img-' + t.key);
      if (media && src) {
        var img = document.createElement('img');
        img.className = 'phtb-img phtb-img--type is-loaded';
        img.src = src;
        img.width = 240;
        img.height = 240;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        media.innerHTML = '';
        media.appendChild(img);
      }
      var label = a.querySelector('.phtb-sc__t');
      if (label) {
        label.textContent = t.label;
        var n = document.createElement('span');
        n.className = 'phtb-sc__n';
        n.setAttribute('data-phtb-sc-n', '');
        label.appendChild(n);
      }
    });
  }

  function init() {
    var all = document.querySelector('.phtb [data-phtb-sc="all"]');
    if (!all) return;
    addCss();
    var view = all.closest('[data-phtb-device]') || all.parentNode;
    upgrade(view);
    var token = 0;

    function tiles() {
      return Array.prototype.slice.call(view.querySelectorAll('[data-phtb-tag]'));
    }

    function apply(feed, t) {
      if (t !== token || !feed || !feed.tabs) return;
      var allN = view.querySelector('[data-phtb-all-n]');
      if (allN && typeof feed.total === 'number' && feed.total > 0) {
        allN.textContent = feed.total + (feed.total === 1 ? ' item' : ' items');
      }
      tiles().forEach(function (a) {
        var info = feed.tabs[FEED[a.getAttribute('data-phtb-sc')]];
        if (!info || typeof info.count !== 'number') return;
        a.hidden = info.count === 0;
        var n = a.querySelector('[data-phtb-sc-n]');
        if (n) n.textContent = info.count + (info.count === 1 ? ' item' : ' items');
      });
    }

    function loadCounts(path, t) {
      var key = 'ph:cs:' + path.split('/').pop();
      try {
        var c = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (c && Date.now() - c.t < TTL) return apply(c.d, t);
      } catch (e) {}
      fetch(path + '?view=ph-sections', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          apply(d, t);
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        })
        .catch(function () {});
    }

    var last = null;
    function sync() {
      var href = all.getAttribute('href');
      var path = colPath(href);
      // Re-assert our links even if ph-tab-bar.js rewrote them in the same pass.
      tiles().forEach(function (a) {
        var want = path ? path + '/' + a.getAttribute('data-phtb-tag') : (href && href !== '#' ? href : null);
        if (want && a.getAttribute('href') !== want) a.setAttribute('href', want);
      });
      var sig = href + '|' + (path || '');
      if (sig === last) return;
      last = sig;
      token++;
      tiles().forEach(function (a) {
        a.hidden = false;
        var n = a.querySelector('[data-phtb-sc-n]');
        if (n) n.textContent = '';
      });
      var allN = view.querySelector('[data-phtb-all-n]');
      if (allN) allN.textContent = '';
      if (path) loadCounts(path, token);
    }

    new MutationObserver(sync).observe(view, { attributes: true, attributeFilter: ['href'], subtree: true });
    sync();
  }

  function start() {
    try { init(); } catch (e) { if (window.console) console.warn('ph-type-tiles', e); }
  }
  // Deferred scripts run in document order and this one sits in the header, before
  // ph-tab-bar.js, so wait for DOMContentLoaded (fires after all deferred scripts).
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* PhoneHub tab bar — My Phone extras.
   1. Samsung series chips (Galaxy S · Z Fold · Z Flip · Galaxy A) switch the model
      list below them; "Change phone" opens the series of the current phone.
   2. Friendlier caption under the phone name ("Saved as your phone" /
      "Detected automatically · not yours? Tap Change phone"). ph-tab-bar.js
      writes its own wording there; this rewrites it. */
(function () {
  'use strict';

  function selectSub(root, key) {
    if (!root || !root.querySelector('[data-phtb-subseg="' + key + '"]')) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-phtb-subseg]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-phtb-subseg') === key ? 'true' : 'false');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-phtb-subpane]'), function (p) {
      p.hidden = p.getAttribute('data-phtb-subpane') !== key;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var chip = t.closest('.phtb [data-phtb-subseg]');
    if (chip) {
      var pane = chip.closest('[data-phtb-pane]');
      selectSub(pane, chip.getAttribute('data-phtb-subseg'));
      var first = pane && pane.querySelector('[data-phtb-subpane]:not([hidden])');
      if (first && chip.scrollIntoView) {
        try { chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (err) {}
      }
      return;
    }
    if (t.closest('.phtb [data-phtb-change]')) {
      var cur = document.querySelector('.phtb [data-phtb-device] [data-phtb-sc="all"]');
      var url = cur && cur.getAttribute('href');
      if (!url || url === '#') return;
      var models = document.querySelectorAll('.phtb [data-phtb-subpane] .phtb-model');
      for (var i = 0; i < models.length; i++) {
        if (models[i].getAttribute('data-url') === url) {
          var sub = models[i].closest('[data-phtb-subpane]');
          selectSub(sub.closest('[data-phtb-pane]'), sub.getAttribute('data-phtb-subpane'));
          break;
        }
      }
    }
  });

  var SAVED = 'Saved as your phone';
  var DETECTED = 'Detected automatically · not yours? Tap Change phone';
  function fixCaption(el) {
    var v = (el.textContent || '').trim();
    var want = /^detected/i.test(v) ? DETECTED : SAVED;
    if (v !== want) el.textContent = want;
  }
  function init() {
    var el = document.querySelector('.phtb [data-phtb-detected-t]');
    if (!el) return;
    fixCaption(el);
    new MutationObserver(function () { fixCaption(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  }
  try {
    if (document.readyState === 'complete') init();
    else document.addEventListener('DOMContentLoaded', init);
  } catch (e) {}
})();

/* PhoneHub tab bar — picking a phone goes straight to its accessories.
   Tapping a model in My Phone (or a model in the "Which iPhone do you have?" /
   "Shop now" coach mark) saves it as before (ph-tab-bar.js runs first, on the
   button itself) and then opens that phone's full collection instead of showing
   the in-sheet summary. The summary still shows when My Phone is opened later. */
(function () {
  'use strict';
  function go(url) {
    if (!url || url === '#') return;
    var here = location.pathname.replace(/\/$/, '');
    var there = url.split('?')[0].replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '');
    if (here === there) {
      var close = document.querySelector('.phtb [data-phtb-sheet="phone"] [data-phtb-close]');
      if (close) close.click();
      return;
    }
    location.assign(url);
  }
  function currentUrl() {
    var a = document.querySelector('.phtb [data-phtb-device] [data-phtb-sc="all"]');
    return a && a.getAttribute('href');
  }
  // Capture phase: the coach mark may rebuild/remove its buttons in its own click
  // handler, so note the tap first and act once every handler has run.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var model = t.closest('.phtb [data-phtb-picker] .phtb-model');
    if (model) {
      var url = model.getAttribute('data-url');
      setTimeout(function () { go(url); }, 0);
      return;
    }
    if (t.closest('.phtb .phtb-pop__choice') || t.closest('.phtb [data-phtb-pop-go]')) {
      // ph-tab-bar.js saves the phone and fills the Shop all link first.
      setTimeout(function () { go(currentUrl()); }, 0);
    }
  }, true);
})();

/* PhoneHub collection grid on phones — "2 per row" / "1 per row" buttons.
   The theme's layout switcher has grid + list. On phones the second button
   becomes "single" (1 per row, image on top, all colours; styles in
   ph-type-tiles.css) instead of the theme's side-by-side list, and it is
   only used when the shopper picks it; 2 per row is the default. Choice saved in
   localStorage "ph:collection-view". Desktop is unchanged. */
(function () {
  'use strict';
  // Own key (not the theme's hypertheme:collection-layout).
  var KEY = 'ph:collection-view';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
  var ICON_SINGLE = '<svg class="icon icon--large icon--thick" aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2.5" width="12" height="9" rx="1.6"/><path d="M4 14.5h12M6.5 17.5h7"/></svg>';

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function setup() {
    if (!mq || !mq.matches) return;
    var sw = document.querySelector('layout-switcher');
    var list = document.getElementById('ProductsList');
    if (!sw || !list) return;
    var grid = sw.querySelector('button[data-layout-mode="grid"]');
    var two = sw.querySelector('button[data-layout-mode="list"], button[data-layout-mode="single"]');
    if (!grid || !two) return;
    if (two.getAttribute('data-layout-mode') !== 'single') {
      two.setAttribute('data-layout-mode', 'single');
      two.setAttribute('aria-label', 'View one per row');
      grid.setAttribute('aria-label', 'View two per row');
      var t = two.querySelector('.btn__text');
      if (t) t.innerHTML = ICON_SINGLE;
    }
    // Keep the card look (grid colour scheme) in the single view too: with equal
    // grid/list classes the theme stops swapping card classes.
    var gc = list.getAttribute('data-grid-class');
    if (gc && !list.getAttribute('data-list-class')) {
      list.setAttribute('data-list-class', gc);
      Array.prototype.forEach.call(list.querySelectorAll('.product-card'), function (c) { c.classList.add(gc); });
    }
    if (!sw.hasAttribute('data-ph-view-bound')) {
      sw.setAttribute('data-ph-view-bound', '');
      [grid, two].forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b === grid ? 'grid' : 'single';
          save(v);
          var l = document.getElementById('ProductsList');
          if (l) l.setAttribute('data-ph-view', v);
        });
      });
    }
    var want = stored() === 'single' ? 'single' : 'grid';
    list.setAttribute('data-ph-view', want);
    if (list.getAttribute('data-layout') !== want || !(want === 'grid' ? grid : two).classList.contains('btn--active')) {
      if (typeof sw.changeLayout === 'function') sw.changeLayout(want === 'grid' ? grid : two, want);
    }
  }

  function init() {
    setup();
    // Filters / sorting / "Shop by type" re-render the product grid: re-apply.
    var box = document.getElementById('ProductGridContainer');
    if (box && window.MutationObserver) {
      new MutationObserver(function () {
        var list = document.getElementById('ProductsList');
        if (list && !list.hasAttribute('data-ph-view')) setup();
      }).observe(box, { childList: true, subtree: false });
    }
    document.addEventListener('collection:rerendered', setup);
    if (mq && mq.addEventListener) mq.addEventListener('change', setup);
  }
  try {
    if (document.readyState === 'complete') init();
    else document.addEventListener('DOMContentLoaded', init);
  } catch (e) {}
})();

/* PhoneHub product cards — tap / click a colour dot to see that colour.
   The theme only swaps the card photo on mouse hover, and a click on a dot
   opened the product page. Now a tap/click on a dot swaps the card's photo to
   that colour's image, marks the dot selected and points the card's links at
   that colour (so opening the product shows it). */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('.product-card .swatches--product-card .swatch-item');
    if (!item) return;
    var card = item.closest('.product-card');
    var vImg = item.querySelector('.color-swatch--variant-image');
    var link = item.querySelector('a[href]');
    e.preventDefault();
    e.stopPropagation();
    var main = card && card.querySelector('.product-card__image--main img');
    if (main && vImg) {
      var src = vImg.getAttribute('src');
      var srcset = vImg.getAttribute('srcset');
      if (src) main.setAttribute('src', src);
      if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
      main.removeAttribute('loading');
    }
    var ul = item.parentNode;
    Array.prototype.forEach.call(ul.querySelectorAll('.swatch-item[aria-selected="true"]'), function (li) {
      if (li !== item) li.removeAttribute('aria-selected');
    });
    item.setAttribute('aria-selected', 'true');
    var href = link && link.getAttribute('href');
    if (card && href) {
      Array.prototype.forEach.call(card.querySelectorAll('a[href*="/products/"]'), function (a) {
        if (a.closest('.swatches')) return;
        a.setAttribute('href', href);
      });
    }
  }, true);
})();

/* PhoneHub header menu button on phones — opens the Shop sheet.
   The tab bar's Shop sheet ("Browse categories & brands") is the store's menu
   on phones, so the header's menu button opens it instead of the theme's menu
   drawer (styles in ph-type-tiles.css). While the sheet is open the button
   shows an X (aria-expanded, theme animation) and tapping it closes the sheet.
   Tablets / desktop (no tab bar) keep the theme's drawer. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
  function shopTab() { return document.querySelector('.phtb [data-phtb-open="shop"]'); }
  function burgers() { return document.querySelectorAll('.header__icons--left .menu-drawer-button'); }
  function active() { return !!(mq && mq.matches && shopTab()); }

  function sync() {
    var tab = shopTab();
    var open = !!tab && tab.getAttribute('aria-expanded') === 'true';
    Array.prototype.forEach.call(burgers(), function (b) {
      if (!active()) return;
      b.setAttribute('aria-controls', 'PhtbSheetShop');
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  // Capture phase on window: runs before the theme's own listener on the button.
  window.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest && t.closest('.header__icons--left .menu-drawer-button');
    if (!b || !active()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var tab = shopTab();
    if (tab.getAttribute('aria-expanded') === 'true') {
      var close = document.querySelector('.phtb [data-phtb-sheet="shop"] [data-phtb-close]');
      if (close) close.click();
    } else {
      tab.click();
    }
  }, true);

  function init() {
    var tab = shopTab();
    if (tab && window.MutationObserver) {
      new MutationObserver(sync).observe(tab, { attributes: true, attributeFilter: ['aria-expanded'] });
    }
    sync();
    if (mq && mq.addEventListener) mq.addEventListener('change', sync);
  }
  try {
    if (document.readyState === 'complete') init();
    else document.addEventListener('DOMContentLoaded', init);
  } catch (e) {}
})();

/* PhoneHub product page — swiping the photos must not move the page.
   Swiping to a colour's photo selects that colour (main-product section
   script); the theme then re-renders the options and focuses the chosen
   colour button, and phones scroll the page down to it. For a few seconds
   after the shopper touches the gallery, focus calls on the variant picker are
   skipped, so the colour still updates but the page stays where it is. A tap
   anywhere outside the gallery ends this straight away. */
(function () {
  'use strict';
  var until = 0;
  var WINDOW = 5000;
  function onDown(e) {
    var t = e.target;
    var inGallery = !!(t && t.closest && t.closest('media-gallery'));
    until = inGallery ? Date.now() + WINDOW : 0;
  }
  function onUp(e) {
    var t = e.target;
    if (t && t.closest && t.closest('media-gallery')) until = Date.now() + WINDOW;
  }
  document.addEventListener('touchstart', onDown, { capture: true, passive: true });
  document.addEventListener('pointerdown', onDown, { capture: true, passive: true });
  document.addEventListener('touchend', onUp, { capture: true, passive: true });
  document.addEventListener('pointerup', onUp, { capture: true, passive: true });
  var focus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function () {
    if (Date.now() < until && this.closest && this.closest('variant-selects, .product-form__input')) return;
    return focus.apply(this, arguments);
  };
})();
